import { Component } from '@angular/core';
import * as XLSX from 'xlsx';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MatModule } from 'src/app/appModules/mat.module';
import { FormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { ApiService } from 'src/app/shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import { last } from 'rxjs';
@Component({
  selector: 'app-student-import',
  standalone: true,
  imports: [CommonModule, MatModule, QuillModule, FormsModule],
  templateUrl: './student-import.component.html'
})
export class StudentImportComponent {
  selectedCourseId: string = '';
  selectedSemesterId: string = '';
  courseList = []; // Load from API
  semesterList = []; // Load from API
  excelData: any[] = [];

  constructor(private http: HttpClient, private api: ApiService, private common: CommonService) { }

  ngOnInit() {
    this.getCourseList();
    this.getSemesterList();
  }

  onFileChange(event: any) {
    const target: DataTransfer = <DataTransfer>event.target;
    if (target.files.length !== 1) return;

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr = e.target.result;
      const workbook = XLSX.read(bstr, { type: 'binary' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      this.excelData = XLSX.utils.sheet_to_json(worksheet, { raw: false });

      this.validateExcelData();
    };
    reader.readAsBinaryString(target.files[0]);
  }
  uploadStudents() {
    if (!this.validRows.length) {
      alert("No valid rows to upload.");
      return;
    }


    this.api.post(`students/import`, this.validRows).subscribe(resp => {

      if (resp.status) {
        this.common.notification(resp.message);
      } else {
        this.common.notification(resp.message);
      }
    });

  }


  validRows: any[] = [];
  invalidRows: { row: number; errors: string[]; data: any }[] = [];

  validateExcelData() {
    this.validRows = [];
    this.invalidRows = [];

    this.excelData.forEach((row, index) => {
      const errors: string[] = [];

      // Validate required fields
      //  if (!row['Student ID']) errors.push("Student ID is missing");
      if (!row['FirstName']) errors.push("first Name is missing");
      if (!row['RegisterNo']) errors.push("Register No is missing");

      // Email format
      // if (row['Email'] && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(row['Email'])) {
      //   errors.push("Invalid email format");
      // }

      // Gender enum
      // const gender = row['Gender']?.toLowerCase();
      // if (gender && !['male', 'female', 'other'].includes(gender)) {
      //   errors.push("Gender must be male, female, or other");
      // }

      // Date format
      // if (row['DOB'] && isNaN(Date.parse(row['DOB']))) {
      //   errors.push("Invalid DOB format");
      // }

      if (errors.length > 0) {
        this.invalidRows.push({ row: index + 2, errors, data: row }); // +2 because headers start at row 1
      } else {
        this.validRows.push({
          student_id: row['StudentId'],
          name: row['FirstName'],
          middle_name: row['MiddleName'],
          last_name: row['LastName'],
          father_name: row['FatherName'],
          mother_name: row['MotherName'],
          profile_pic: row['Photo'],
          register_no: row['RegisterNo'],
          scheme_type: row['SchemeType'],
          course_id: this.selectedCourseId,
          section:row['section'],
          semester_id: '',
          // section: row['Section'],
          email: row['Email'],
          phone: row['Phone'],
          gender: row['Gender'],
          //  dob: row['DOB'] ? new Date(row['DOB']) : null
        });
      }
    });
  }

  getCourseList() {
    this.api.get(`courses/list`).subscribe(resp => {
      if (resp && resp.success) {
        this.courseList = resp.data;
      } else {
        console.error('Failed to load courses:', resp);
        this.courseList = [];
      }
    });
  }

  getSemesterList() {
    this.api.get(`semesters/list`).subscribe(resp => {
      if (resp && resp.success) {
        this.semesterList = resp.data;
      } else {
        console.error('Failed to load semesters:', resp);
        this.semesterList = [];
      }
    });
  }





}
